import React, { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import {
  PEER_STATUS_COLOR,
  PEER_STATUS_TEXT,
} from 'screens/performanceReview/LandingPage/components/ReviewsPendingOnOthersComps/ReviewRowDisplay';

import { REVIEW_PEER_STATUS, REVIEW_SUBMISSION_STATUS_MAP } from 'constants/ProjectConstants';

import { Avatar } from 'uiToolkitV1/Avatar';
import { Button } from 'uiToolkitV1/Button';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { TagColored } from 'uiToolkitV1/Tag';

const calculateStatusTextAndColor = ({ review }) => {
  if (!review.submissionStatus) {
    // local just added case, and we don't have review data cause the api just returns success message only
    return review.peerStatus === 'isAccepted' ? ['In-Progress', 'yellow'] : ['Nominated', 'black'];
  }
  let infoChipColor = 'yellow';
  let infoChipText = '';

  if (review.peerStatus && review.peerStatus === REVIEW_PEER_STATUS.DECLINED) {
    infoChipColor = PEER_STATUS_COLOR[review.peerStatus];
    infoChipText = PEER_STATUS_TEXT[review.peerStatus];
  } else {
    infoChipText = REVIEW_SUBMISSION_STATUS_MAP[review.submissionStatus].statusText;
    infoChipColor = REVIEW_SUBMISSION_STATUS_MAP[review.submissionStatus].infoChipColor;
  }

  return [infoChipText, infoChipColor];
};

const AvatarComponent = (employee) => () => <Avatar src={employee?.profilePhoto ?? employee?.profilePhotoSrc ?? ''} />;

const EmployeeBlock = ({ employee, removeNomination, details }) => {
  const [infoChipText, infoChipColor] = calculateStatusTextAndColor({ review: details.review });
  const [isLoading, setIsLoading] = useState(false);

  const handleRemoveNomination = () => {
    setIsLoading(true);
    removeNomination({ details }).finally(() => setIsLoading(false));
  };

  return (
    <Flex gap="28px" justify="space-between" alignItems="center">
      <Box maxW="50%">
        <ListItemComp
          title={employee.displayName}
          subTitle={employee.designation}
          LeftComponent={AvatarComponent(employee)}
          withoutBackground
          isBoldText={false}
        />
      </Box>
      <Flex alignItems="center">
        <TagColored color={infoChipColor}>{infoChipText}</TagColored>

        {details.allowReviewFormWithdraw && (
          <Button variant="tertiary" onClick={handleRemoveNomination} disabled={isLoading}>
            Withdraw
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default EmployeeBlock;
